export const categories = [
  {
    slug: 'tropical-islands',
    name: '热带海岛',
    description: '碧海蓝天，白沙滩与椰林树影，亚洲最美的海岛度假胜地',
    icon: 'ri-anchor-line',
  },
  {
    slug: 'ancient-capitals',
    name: '古都文化',
    description: '千年历史的沉淀，探访亚洲最迷人的古都遗迹与文化圣地',
    icon: 'ri-building-2-line',
  },
  {
    slug: 'mountain-secrets',
    name: '山川秘境',
    description: '远离尘嚣，深入亚洲最壮丽的山川峡谷与自然奇观',
    icon: 'ri-landscape-line',
  },
  {
    slug: 'urban-romance',
    name: '都市风情',
    description: '霓虹璀璨的亚洲都市，美食、购物与现代文化的完美交融',
    icon: 'ri-community-line',
  },
  {
    slug: 'wellness-retreat',
    name: '养生度假',
    description: '身心疗愈之旅，亚洲顶级温泉、瑜伽与SPA度假体验',
    icon: 'ri-psychotherapy-line',
  },
  {
    slug: 'culinary-journey',
    name: '美食之旅',
    description: '舌尖上的亚洲，从街头小吃到米其林餐厅的美食探索',
    icon: 'ri-restaurant-line',
  },
];

export const destinations = [
  {
    slug: 'bali',
    name: '巴厘岛',
    country: '印度尼西亚',
    tag: '热门推荐',
    description: '神之岛屿，融合绝美海滩、梯田稻浪与千年印度教文化的度假天堂。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bali%20Indonesia%20tropical%20paradise%20with%20ancient%20temple%20on%20cliff%20overlooking%20ocean%20lush%20green%20rice%20terraces%20golden%20sunset%20serene%20atmosphere%20travel%20destination&width=800&height=500&seq=dest-bali-home-v2&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Bali%20tropical%20paradise%20with%20rice%20terraces%20and%20ancient%20temples%20lush%20green%20landscape%20morning%20mist%20golden%20light%20traditional%20Balinese%20architecture%20serene%20atmosphere&width=1200&height=600&seq=dest-bali-detail-v2&orientation=landscape',
  },
  {
    slug: 'kyoto',
    name: '京都',
    country: '日本',
    tag: '文化之旅',
    description: '千年古都，金阁寺、伏见稻荷与岚山竹林，感受日本传统文化精髓。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Kyoto%20Japan%20ancient%20temple%20with%20maple%20trees%20in%20autumn%20colors%20traditional%20wooden%20architecture%20zen%20garden%20geisha%20district%20soft%20golden%20afternoon%20light&width=800&height=500&seq=dest-kyoto-home-v2&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Kyoto%20Japan%20autumn%20maple%20leaves%20at%20ancient%20temple%20red%20and%20golden%20foliage%20traditional%20pagoda%20zen%20garden%20soft%20morning%20light%20peaceful&width=1200&height=600&seq=dest-kyoto-detail-v2&orientation=landscape',
  },
  {
    slug: 'maldives',
    name: '马尔代夫',
    country: '马尔代夫',
    tag: '蜜月首选',
    description: '印度洋上的珍珠项链，水上别墅与珊瑚礁环绕的终极海岛度假地。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Maldives%20luxury%20overwater%20villas%20with%20crystal%20clear%20turquoise%20lagoon%20white%20sand%20beach%20palm%20trees%20vibrant%20coral%20reef%20tropical%20sunset%20romantic&width=800&height=500&seq=dest-maldives-home-v2&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Maldives%20luxury%20overwater%20villa%20with%20infinity%20pool%20crystal%20clear%20turquoise%20water%20white%20sand%20sunset%20view%20palm%20trees%20romantic%20paradise&width=1200&height=600&seq=dest-maldives-detail-v2&orientation=landscape',
  },
  {
    slug: 'chiang-mai',
    name: '清迈',
    country: '泰国',
    tag: '文艺小城',
    description: '泰北玫瑰，古城寺庙与创意市集交织，慢生活的文艺旅行目的地。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chiang%20Mai%20Thailand%20ancient%20temple%20with%20golden%20stupa%20surrounded%20by%20mountains%20traditional%20night%20market%20colorful%20lanterns%20lush%20tropical%20greenery&width=800&height=500&seq=dest-chiangmai-home-v2&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Chiang%20Mai%20Thailand%20ancient%20temple%20among%20mountains%20morning%20mist%20golden%20stupa%20traditional%20lanterns%20lush%20tropical%20garden%20peaceful&width=1200&height=600&seq=dest-chiangmai-detail-v2&orientation=landscape',
  },
  {
    slug: 'seoul',
    name: '首尔',
    country: '韩国',
    tag: '潮流之都',
    description: '传统与现代的完美碰撞，景福宫与明洞、弘大潮流文化的双重魅力。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Seoul%20South%20Korea%20ancient%20palace%20with%20modern%20city%20skyline%20background%20cherry%20blossoms%20traditional%20hanbok%20colorful%20night%20street%20neon%20signs&width=800&height=500&seq=dest-seoul-home-v2&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Seoul%20South%20Korea%20trendy%20shopping%20street%20with%20neon%20signs%20fashionable%20people%20modern%20cafe%20K-pop%20culture%20vibrant%20night%20atmosphere&width=1200&height=600&seq=dest-seoul-detail-v2&orientation=landscape',
  },
  {
    slug: 'da-nang',
    name: '岘港',
    country: '越南',
    tag: '新兴胜地',
    description: '人生必去的海滨城市，巴拿山金色大桥与美溪海滩的完美假期。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Da%20Nang%20Vietnam%20beautiful%20coastal%20city%20with%20golden%20bridge%20on%20mountain%20white%20sandy%20beach%20blue%20sea%20modern%20skyline%20traditional%20fishing%20boats&width=800&height=500&seq=dest-danang-home-v2&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Da%20Nang%20Vietnam%20golden%20bridge%20with%20stone%20hands%20on%20mountain%20overlooking%20coastline%20blue%20sky%20dramatic%20clouds%20tropical%20greenery&width=1200&height=600&seq=dest-danang-detail-v2&orientation=landscape',
  },
];

export const articles = [
  {
    slug: 'bali-ultimate-guide-2025',
    title: '2025巴厘岛终极旅行攻略：住宿、美食与景点全收录',
    excerpt: '从乌布稻田到乌鲁瓦图悬崖，从库塔冲浪到金巴兰日落，这份巴厘岛深度攻略带你领略众神之岛的每一面。',
    category: 'tropical-islands',
    categoryName: '热带海岛',
    author: '林小雨',
    date: '2025-07-20',
    readTime: '12分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Bali%20tropical%20paradise%20with%20rice%20terraces%20and%20ancient%20temples%20lush%20green%20landscape%20morning%20mist%20golden%20light%20traditional%20Balinese%20architecture&width=600&height=400&seq=article-bali-home&orientation=landscape',
    content: `巴厘岛，这座被誉为"众神之岛"的印尼明珠，是无数旅行者心中的终极度假胜地。2025年，随着更多直飞航线的开通和高端度假村的落成，巴厘岛正以全新的面貌迎接世界各地的游客。

## 最佳旅行时间

巴厘岛属于热带海岛气候，全年温暖湿润。最佳旅行季节是4月到10月的旱季，此时阳光充足、湿度适中，非常适合海滩活动和户外探索。11月到次年3月是雨季，但阵雨通常来得快去得也快，而且此时游客较少，价格也更为亲民。

## 必游景点推荐

### 海神庙（Tanah Lot）
坐落在海边巨岩上的海神庙是巴厘岛最具标志性的景点之一。每当涨潮时，寺庙宛如漂浮在海面上，日落时分更是美得令人窒息。

### 乌布皇宫与圣猴森林
乌布是巴厘岛的文化艺术中心。乌布皇宫展现了巴厘传统建筑的精美，而圣猴森林则是与长尾猕猴亲密接触的绝佳去处。

### 德格拉朗梯田
这片被联合国教科文组织列为世界遗产的梯田景观，是巴厘岛最上镜的地点之一。清晨薄雾缭绕时，层层叠叠的绿色梯田构成了一幅绝美的画卷。

## 美食探索

巴厘岛的美食同样令人难忘。从酥脆的脏鸭餐（Bebek Bengil）到香气四溢的烤猪饭（Babi Guling），从街边摊的沙爹烤串到精致餐厅的创意料理，每一餐都是一场味蕾的冒险。

## 行程建议

如果时间充裕，建议在巴厘岛停留至少5-7天。乌布住2-3天感受文化，南部海滩住2-3天享受阳光沙滩，最后留一天去北部的罗威纳看海豚。`,
  },
  {
    slug: 'kyoto-autumn-leaves-journey',
    title: '京都赏枫全攻略：十大绝美红叶名所与最佳观赏期',
    excerpt: '秋季的京都如同一幅流动的画卷，从岚山竹林到清水寺，每一处都是值得用镜头定格的绝美瞬间。',
    category: 'ancient-capitals',
    categoryName: '古都文化',
    author: '张明远',
    date: '2025-06-15',
    readTime: '15分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Kyoto%20Japan%20autumn%20maple%20leaves%20at%20ancient%20temple%20red%20and%20golden%20foliage%20traditional%20pagoda%20zen%20garden%20soft%20morning%20light&width=600&height=400&seq=article-kyoto-home&orientation=landscape',
    content: `京都，这座拥有千年历史的古都，每年秋季都会化身为一片红色的海洋。红叶与古寺的完美结合，让京都成为全球赏枫爱好者的朝圣之地。

## 最佳赏枫时间

京都的红叶季通常在11月中旬到12月上旬。根据海拔和品种的不同，各寺庙的红叶观赏期略有差异。建议在11月下旬前往，此时大部分红叶名所都处于最佳观赏状态。

## 十大红叶名所

### 清水寺
作为京都最著名的地标之一，清水寺的夜枫尤为壮观。当灯光照亮满山的红叶时，整座寺庙仿佛笼罩在一片温暖的红光之中。

### 岚山竹林与天龙寺
岚山不仅有闻名世界的竹林小径，天龙寺的曹源池庭园也是赏枫的绝佳去处。红叶倒映在池水中，与枯山水庭园交相辉映。

### 永观堂
被誉为"红叶的永观堂"，这里的枫树数量多达3000余株。回廊式的建筑结构让游客可以从不同角度欣赏红叶的美丽。

### 东福寺
通天桥是东福寺最著名的赏枫地点。从桥上俯瞰，整个山谷被红叶覆盖，景色极为壮观。

### 贵船神社
位于京都北部的贵船神社，以其石阶两旁的红叶灯笼而闻名。傍晚时分，石灯笼与红叶相互映衬，营造出梦幻般的氛围。

## 赏枫实用贴士

建议穿着舒适的步行鞋，因为京都赏枫需要大量步行。早上8点前到达热门景点可以避开人潮。购买京都巴士一日券非常划算，可以无限次乘坐市内巴士。`,
  },
  {
    slug: 'maldives-water-villa-experience',
    title: '马尔代夫水上别墅全体验：选岛攻略与预算规划',
    excerpt: '从性价比岛到顶级奢华岛，马尔代夫选岛终极指南，帮你找到最适合的印度洋度假天堂。',
    category: 'tropical-islands',
    categoryName: '热带海岛',
    author: '陈思琪',
    date: '2025-05-28',
    readTime: '10分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Maldives%20luxury%20overwater%20villa%20with%20infinity%20pool%20crystal%20clear%20turquoise%20water%20white%20sand%20sunset%20view%20palm%20trees%20romantic&width=600&height=400&seq=article-maldives-home&orientation=landscape',
    content: `马尔代夫，这个由1190个珊瑚岛组成的印度洋岛国，是全球最令人向往的海岛度假目的地。一岛一酒店的模式让每个度假村都拥有独特的风格和体验。

## 如何选岛

选岛是马尔代夫旅行中最关键的一步。你需要考虑以下几个因素：

### 预算
马尔代夫的度假村价格跨度很大，从每晚几百美元的性价比岛到每晚数千美元的顶级奢华岛都有。确定预算范围可以帮助你快速缩小选择范围。

### 上岛方式
距离马累机场较近的岛屿可以乘坐快艇到达（约20-60分钟），稍远的岛屿需要乘坐水上飞机（约30-60分钟），最远的岛屿则需要内陆飞机加快艇的接驳。

### 浮潜条件
如果你热爱浮潜，选择拥有优质珊瑚礁的岛屿非常重要。一些岛屿的珊瑚礁就在岸边，从水上别墅的台阶下去就能与热带鱼共游。

## 水上别墅体验

住在水上别墅是马尔代夫旅行最经典的体验。清晨醒来，推开落地窗就能跃入碧蓝的印度洋；夜晚躺在床上，透过玻璃地板就能看到游过的鱼群。

## 推荐岛屿

### 性价比之选：班度士岛
距离马累仅15分钟快艇，拥有绝佳的浮潜环境，是预算有限的旅行者的理想选择。

### 经典之选：康莱德岛
全球首家水下餐厅所在地，拥有两个独立岛屿，提供丰富的水上活动和餐饮选择。

### 奢华之选：白马庄园
LVMH集团旗下的顶级度假村，每一栋别墅都配有私人泳池和专属管家服务。`,
  },
  {
    slug: 'chiang-mai-slow-life-guide',
    title: '清迈慢生活指南：咖啡馆、夜市与寺庙的完美七日',
    excerpt: '在泰北玫瑰清迈，放慢脚步感受古城韵味，从宁曼路咖啡馆到素贴山日落，享受七天文艺慢旅。',
    category: 'mountain-secrets',
    categoryName: '山川秘境',
    author: '王艺琳',
    date: '2025-04-12',
    readTime: '11分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chiang%20Mai%20Thailand%20ancient%20temple%20among%20mountains%20morning%20mist%20golden%20stupa%20traditional%20lanterns%20lush%20tropical%20garden&width=600&height=400&seq=article-chiangmai-home&orientation=landscape',
    content: `清迈，这座被群山环抱的泰北古城，以其悠闲的生活节奏和浓郁的文化氛围吸引着世界各地的旅行者。在这里，你可以彻底放慢脚步，享受一段真正的慢时光。

## 清迈的魅力

与曼谷的喧嚣繁华不同，清迈保留着一种从容不迫的气质。古城墙内的寺庙钟声、宁曼路的文艺咖啡馆、周末夜市的烟火气，共同构成了清迈独特的城市肌理。

## 七日慢生活行程

### 第一天：古城寺庙巡礼
从帕辛寺到契迪龙寺，清迈古城内分布着数十座古老的佛寺。清晨跟随僧侣的布施队伍，感受最纯正的泰北人文气息。

### 第二天：宁曼路文艺漫步
宁曼路是清迈最具文艺气息的街区。这里有数不清的独立咖啡馆、设计师店铺和艺术画廊。找一家喜欢的咖啡馆，点一杯泰北咖啡，度过一个慵懒的下午。

### 第三天：素贴山与双龙寺
登上素贴山，在双龙寺的观景台上俯瞰整个清迈城。傍晚时分，金色的夕阳洒在城市上空，美得令人心醉。

### 第四天：清迈夜市
清迈的周末夜市是亚洲最著名的夜市之一。从手工艺品到街头美食，琳琅满目的摊位让人流连忘返。

## 清迈必尝美食

泰北咖喱面（Khao Soi）是清迈最具代表性的美食。黄咖喱汤底配上蛋面和脆面，再撒上酸菜和青柠汁，层次丰富的口感令人难忘。`,
  },
  {
    slug: 'seoul-fashion-food-trend',
    title: '首尔潮流探店：弘大、圣水洞与明洞的最新打卡地图',
    excerpt: '2025首尔最新潮流趋势全解析，从设计师品牌到街头美食，带你逛遍首尔最in的打卡圣地。',
    category: 'urban-romance',
    categoryName: '都市风情',
    author: '赵雪儿',
    date: '2025-03-08',
    readTime: '13分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Seoul%20South%20Korea%20trendy%20shopping%20street%20with%20neon%20signs%20fashionable%20people%20modern%20cafe%20vibrant%20night%20atmosphere&width=600&height=400&seq=article-seoul-home&orientation=landscape',
    content: `首尔，这座亚洲潮流文化的风向标，每一次转身都可能遇见新的惊喜。从弘大的独立音乐到圣水洞的工业风咖啡馆，从明洞的美妆天堂到梨泰院的多元文化，首尔的每个街区都有独特的个性。

## 弘大：青春与创意的中心

弘大周边是首尔最具活力的区域之一。这里聚集了弘益大学的学生、独立音乐人和街头艺术家。白天可以逛遍各种设计师品牌店和复古商店，晚上则在街头欣赏免费的街头表演。

### 必逛店铺
- Object：三层楼高的文创集合店，汇集了韩国独立设计师的作品
- Nerdy：韩国潮牌代表，运动休闲风的标杆
- Ader Error：解构主义设计，每一季都令人惊艳

## 圣水洞：工业美学的复兴

曾经的皮鞋工厂区如今摇身一变，成为首尔最热门的文化街区。红砖厂房改造的咖啡馆、展览空间和设计师店铺，让圣水洞充满了独特的工业美学魅力。

## 明洞：美妆与美食天堂

明洞是首尔最繁华的购物区之一。这里汇集了韩国各大美妆品牌的旗舰店，街边小吃摊更是琳琅满目。从炒年糕到旋风土豆，从韩牛烤肉到参鸡汤，明洞的美食永远不会让人失望。

## 首尔出行贴士

首尔地铁系统非常发达，建议购买T-money交通卡。大部分热门景点都可乘坐地铁到达。如果计划大量购物，记得带上护照以便办理退税。`,
  },
  {
    slug: 'da-nang-hoi-an-journey',
    title: '岘港+会安双城记：越南中部的海滨与古城之旅',
    excerpt: '从岘港的金色沙滩到会安的灯笼古城，越南中部双城串联出一段完美的东南亚度假体验。',
    category: 'tropical-islands',
    categoryName: '热带海岛',
    author: '刘浩然',
    date: '2025-02-20',
    readTime: '9分钟',
    coverUrl: 'https://readdy.ai/api/search-image?query=Hoi%20An%20Vietnam%20ancient%20town%20with%20colorful%20lanterns%20hanging%20over%20canal%20traditional%20yellow%20buildings%20night%20market%20warm%20glowing%20lights%20river&width=600&height=400&seq=article-hoian-home&orientation=landscape',
    content: `越南中部的岘港和会安，一个现代化海滨城市和一个保存完好的古镇，仅有30分钟车程的距离，却呈现出截然不同的旅行体验。

## 岘港：人生必去的海滨城市

岘港拥有被誉为"全球最美六大海滩之一"的美溪海滩。细腻的白沙、清澈的海水和绵延的海岸线，让这里成为东南亚最受欢迎的海滨度假地之一。

### 巴拿山
距离市区约40公里的巴拿山，以其标志性的金色大桥闻名于世。两只巨大的石手托起金色桥身，漫步其上仿佛行走在云端。

### 山茶半岛
这座伸入海中的半岛是岘港的天然屏障。山顶的灵应寺矗立着高达67米的观音像，从山顶俯瞰整个岘港海岸线，景色壮丽。

## 会安：被时光遗忘的古城

会安古镇是联合国教科文组织世界文化遗产。这里保留了大量16-18世纪的古建筑，融合了越南、中国、日本和法国的建筑风格。

### 灯笼之夜
每逢农历十四，会安全城会熄灭电灯，只点亮五彩缤纷的丝绸灯笼。整座古镇沉浸在温暖柔和的光晕中，仿佛穿越回了数百年前。

### 会安美食
会安米粉（Cao Lau）是会安的招牌美食。粗米粉配上叉烧肉、脆猪皮和新鲜蔬菜，浇上特制的酱汁，口感丰富层次分明。`,
  },
];